const DropDownProfile = ({dropdownRef, handleMouseEnter, handleMouseLeave, handleClick, showDropdown, Link}) => {
  
     return(
      <>
          <div className="box-wishlist">
              <div
                className="dropdown"
                ref={dropdownRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                >
                <button
                  className="btn btn-secondary dropdown-toggle bg-remove"
                  type="button"
                  onClick={handleClick}
                  aria-expanded={showDropdown}
                  style={{padding: "0px", display: "inline-flex", background:"transparent", border:"none", alignItems:"center"}} > 
                    <span style={{ marginRight: "5px"}}>  <img src="https://b2b.obsessions.co.in/public/design/img/user/user_avatar.svg" height={20} className="img-responsive" alt="user"  /> </span>
                      Dileep
                </button>
                <ul
                  className={`dropdown-menu${showDropdown ? " show" : ""}`}
                  style={{ position: "absolute", backgroundColor: "#0000007a" }} >
                  <li><Link className="dropdown-item" to="/my-profile"><i className="bi bi-people"></i> My Profile </Link></li>
                  <li><Link className="dropdown-item" to="/ChangePassword"><i className="bi bi-key"></i> Change Password </Link></li>
                  <li><Link className="dropdown-item" to="/"><i className="bi bi-box-arrow-right"></i> Sign Logout </Link></li>
                </ul>
              </div>
            </div>

      </>

     )
}
export default DropDownProfile;